var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinterest = function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.8,
    cy: 24.8,
    r: 24.8,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "M23.2 28.56a5.278 5.278 0 0 0 4.96 1.76 6.958 6.958 0 0 0 4.4-2.96 10.638 10.638 0 0 0 1.76-5.12 8.88 8.88 0 0 0-5.04-8.72c-3.68-1.6-8.88-.8-11.6 2.32a10.71 10.71 0 0 0-2.08 3.44 6.641 6.641 0 0 0 .08 4.8A6.255 6.255 0 0 0 16.96 26c.16.08 1.84 1.2 1.84 1.04 0-.16.4-1.28.56-1.84a.96.96 0 0 0-.16-.8 4.96 4.96 0 0 1-.8-4.24 6.558 6.558 0 0 1 2.88-3.68 6.397 6.397 0 0 1 6.64-.16c2.48 1.44 2.88 4.64 2.32 7.36a6.97 6.97 0 0 1-1.2 2.72 3.361 3.361 0 0 1-2.72 1.36 2.078 2.078 0 0 1-1.92-2.72l.88-3.36c.24-.96.48-1.92-.16-2.72a2.238 2.238 0 0 0-1.92-.8 2.96 2.96 0 0 0-2.4 2.72 6.403 6.403 0 0 0 .48 3.2l-1.76 7.04a10.79 10.79 0 0 0-.24 3.2l.16 2.4a.32.32 0 0 0 .56.16l1.2-1.92a10.147 10.147 0 0 0 1.36-3.2l.64-3.2z"
  }))));
};
export default SvgPinterest;